/* So You! Clothing Personality Quiz (sections/sy-quiz.liquid). Plain JS, no libraries.
   Unlocked when the section setting is ticked, or when the page address has ?quiz=preview (DI testing). */
(function () {
  /* Debbie's questionnaire: answers A to F always count towards these personalities, in this order. */
  var ORDER = ['DC', 'NC', 'DF', 'CE', 'CR', 'EC'];
  /* Tie-break order, as on the approved mockup. */
  var KEYS = ['CE', 'EC', 'NC', 'DF', 'DC', 'CR'];
  /* Everyone has a secondary. If no other personality scored (every answer the same letter), use the closest one. */
  var FALLBACK = { CE: 'EC', EC: 'CE', NC: 'CE', DF: 'CE', DC: 'EC', CR: 'DC' };

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function init(root) {
    var params = null, preview = false, link = null;
    try { params = new URLSearchParams(window.location.search); preview = params.get('quiz') === 'preview'; } catch (e) {}
    /* Paid link from the order confirmation email: ?o=ORDER&t=SIGNATURE (checked by the DI quiz function). */
    if (params && params.get('o') && params.get('t') && root.dataset.quizApi) {
      link = { o: params.get('o'), t: params.get('t') };
      fetch(root.dataset.quizApi + '?o=' + encodeURIComponent(link.o) + '&t=' + encodeURIComponent(link.t), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res.ok) throw new Error('bad link');
          run(root, link, res.answers);
        })
        .catch(function () {
          var box = root.querySelector('[data-quiz-locked]');
          if (box && root.dataset.badLink) box.insertAdjacentHTML('afterbegin', '<p class="sy-quiz__badlink" role="alert">' + esc(root.dataset.badLink) + '</p>');
        });
      return;
    }
    if (root.getAttribute('data-unlocked') !== 'true' && !preview) return; /* stays locked: Buy box shows */
    run(root, null, null);
  }

  function run(root, link, savedAnswers) {

    var q = function (sel) { return root.querySelector(sel); };
    var locked = q('[data-quiz-locked]');
    var start = q('[data-quiz-start]');
    var card = q('[data-quiz-questions]');
    var result = q('[data-quiz-result]');
    var stepEl = q('[data-quiz-step]');
    var bar = q('[data-quiz-bar]');
    var back = q('[data-quiz-back]');
    var next = q('[data-quiz-next]');
    var qs = [].slice.call(root.querySelectorAll('[data-quiz-q]'));
    var d = root.dataset;
    var i = 0;

    locked.hidden = true;
    start.hidden = false;
    if (!qs.length) return;
    /* Paid link: hide the sales hero and Buy parts so she lands straight on the start screen. */
    if (link) { hideRest(); setTimeout(top, 0); }
    if (savedAnswers && savedAnswers.length) {
      /* Bought and done already: show her results again (no retakes). */
      setTimeout(function () {
        savedAnswers.forEach(function (a, n) { var r = qs[n] && qs[n].querySelector('input[value="' + a + '"]'); if (r) r.checked = true; });
        hideRest(); start.hidden = true; showResult();
      }, 0);
    }

    function slot(name) { return root.querySelector('[data-slot="' + name + '"]'); }
    function type(key) { return root.querySelector('[data-quiz-store] [data-quiz-type="' + key + '"]'); }
    function checked(n) { return qs[n].querySelector('input:checked'); }
    function top() { window.scrollTo(0, root.getBoundingClientRect().top + window.pageYOffset - 24); }

    function hideRest() {
      if (d.hideRest !== 'true') return;
      var mine = root.closest('.shopify-section');
      [].forEach.call(document.querySelectorAll('#MainContent > .shopify-section'), function (s) {
        if (s !== mine) s.hidden = true;
      });
    }

    function draw(focus) {
      qs.forEach(function (f, k) { f.hidden = k !== i; });
      stepEl.textContent = d.stepLabel.replace('[n]', i + 1).replace('[total]', qs.length);
      bar.style.width = ((i + 1) / qs.length) * 100 + '%';
      back.classList.toggle('is-hidden', i === 0);
      back.disabled = i === 0;
      next.disabled = !checked(i);
      next.textContent = i === qs.length - 1 ? d.finishLabel : d.nextLabel;
      if (focus) qs[i].querySelector('h2').focus();
    }

    root.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') return;
      [].forEach.call(qs[i].querySelectorAll('.sy-quiz__opt'), function (l) {
        l.classList.toggle('is-checked', l.contains(e.target) && e.target.checked);
      });
      next.disabled = false;
    });

    q('[data-quiz-begin]').addEventListener('click', function () {
      hideRest();
      start.hidden = true;
      card.hidden = false;
      i = 0;
      draw(false);
      top();
      qs[0].querySelector('h2').focus();
    });

    back.addEventListener('click', function () {
      if (i > 0) { i--; draw(true); }
    });

    next.addEventListener('click', function () {
      if (!checked(i)) return;
      if (i < qs.length - 1) { i++; draw(true); } else { showResult(); }
    });

    function showResult() {
      var score = {};
      var keys = KEYS.filter(function (k) { return type(k); });
      keys.forEach(function (k) { score[k] = 0; });
      qs.forEach(function (f) {
        var c = f.querySelector('input:checked');
        var k = c && ORDER[+c.value];
        if (k in score) score[k]++;
      });
      var order = keys.slice().sort(function (a, b) { return score[b] - score[a]; });
      var main = order[0];
      var second = order[1];
      if (!score[second] && type(FALLBACK[main])) second = FALLBACK[main];

      var T = type(main);
      var S = type(second);
      var name = T.getAttribute('data-name');
      var sName = S ? S.getAttribute('data-name') : '';

      slot('name').textContent = name;
      slot('chip').textContent = d.secondaryChip.replace('[personality]', sName);
      slot('chip').parentNode.hidden = !S;
      slot('text').innerHTML = T.querySelector('[data-part="text"]').innerHTML;
      slot('second').innerHTML = S && d.secondaryText
        ? '<p>' + esc(d.secondaryText)
            .replace('[personality]', '<strong>' + esc(sName) + '</strong>')
            .replace('[short]', esc(S.getAttribute('data-short') || '')) + '</p>'
        : '';
      slot('meter').innerHTML = order.filter(function (k) { return score[k]; }).map(function (k) {
        return '<div><b>' + esc(type(k).getAttribute('data-name')) + '</b><span><i style="width:' +
          Math.round((score[k] / qs.length) * 100) + '%"></i></span></div>';
      }).join('');
      slot('tips').innerHTML = '';
      slot('tips').appendChild(T.querySelector('[data-part="tips"]').cloneNode(true));

      /* Picks: moved (not copied) from the hidden store so each product card appears once. */
      var picks = T.querySelector('[data-part="picks"]');
      slot('picks-wrap').hidden = !picks;
      if (picks) {
        slot('picks-heading').textContent = d.picksHeading.replace('[personality]', name);
        if (T.getAttribute('data-url')) slot('picks-link').href = T.getAttribute('data-url');
        slot('picks').appendChild(picks);
      }
      var sPicks = S && S.querySelector('[data-part="picks"]');
      slot('second-wrap').hidden = !sPicks;
      if (sPicks) {
        slot('second-heading').textContent = d.secondHeading.replace('[personality]', sName);
        slot('second-picks').appendChild(sPicks);
      }

      try {
        localStorage.setItem('sy-quiz', JSON.stringify({ style: name, second: sName }));
      } catch (e) {}
      if (link && !savedAnswers) {
        var answers = qs.map(function (f) { var c = f.querySelector('input:checked'); return c ? +c.value : 0; });
        fetch(root.dataset.quizApi, { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ o: link.o, t: link.t, answers: answers, style: name, second: sName }) }).catch(function () {});
      }

      card.hidden = true;
      result.hidden = false;
      top();
      slot('name').focus();
    }
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-sy-quiz]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Theme editor: re-run when the section is edited. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-sy-quiz]');
    if (el) init(el);
  });
})();
